export enum ToastPositionEnum {
    top = 'is-top',
    right = 'is-right',
    left = 'is-left',
    bottom = 'is-bottom',
}

export type ToastPosition = ToastPositionEnum.top | ToastPositionEnum.right | ToastPositionEnum.left |
    ToastPositionEnum.bottom;
